import { Box } from '@mantine/core';
import { UsersTable } from './users/components/UsersTable';
import { AdminTabs, useAdminTabs } from './hooks/useAdminTabs';
import { useMemo } from 'react';
import UnderlineTabsDeprecated from 'src/UI/page-nav/UnderlineTabsDeprecated';

export default function AdminPage() {
  const { currentTab, setTab } = useAdminTabs();

  const tabContent = useMemo(() => {
    if (currentTab === AdminTabs.Users) {
      return <UsersTable />;
    }

    if (currentTab === AdminTabs.Appearance) {
      return <Box>Appearance settings will be here.</Box>;
    }
  }, [currentTab]);

  return (
    <Box p="md">
      <UnderlineTabsDeprecated
        value={currentTab}
        onChange={value => {
          if (value != null) {
            setTab(value as AdminTabs);
          }
        }}
      >
        <UnderlineTabsDeprecated.List>
          <UnderlineTabsDeprecated.Tab value={AdminTabs.Users}>Users</UnderlineTabsDeprecated.Tab>
        </UnderlineTabsDeprecated.List>

        <Box mt="sm">{tabContent}</Box>
      </UnderlineTabsDeprecated>
    </Box>
  );
}
